import { keywordTicker, heroHeadline, heroLead, heroQuick, heroFeature } from "@/mocks/cgua";

export default function Hero() {
  const tickerItems = [...keywordTicker, ...keywordTicker];
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      {/* decorative watermark + shapes */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <span className="absolute -top-10 -right-6 select-none font-heading text-[16rem] leading-none font-black text-primary-500/[0.05]">
          瓜
        </span>
        <span className="absolute bottom-6 left-1/2 w-24 h-24 rounded-full bg-accent-300/30 blur-2xl" />
        <span className="absolute top-10 left-1/3 w-16 h-16 rounded-full bg-primary-200/40 blur-xl" />
      </div>

      {/* keyword ticker */}
      <div className="relative marquee-pause border-b border-background-200 bg-background-50/70">
        <div className="flex overflow-hidden">
          <div className="animate-marquee flex items-center gap-10 px-5 py-2.5 whitespace-nowrap min-w-max">
            {tickerItems.map((k, i) => (
              <span key={i} className="flex items-center gap-2 text-sm font-semibold text-foreground-700">
                {k.type === "hot" && <i className="ri-fire-fill text-primary-500" />}
                {k.type === "up" && <i className="ri-arrow-up-line text-accent-700" />}
                {k.word}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="relative mx-auto max-w-[1200px] px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* 文案优先：主文案区 */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="inline-flex items-center gap-2 self-start rounded-full bg-accent-500 text-foreground-950 text-xs font-bold px-3.5 py-1.5 mb-5">
              <i className="ri-sparkling-2-fill text-[14px]" />
              今日速览 · 一口吃完当天瓜
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-[2.9rem] font-black leading-[1.15] tracking-tight text-foreground-950">
              <span className="font-heading">全网热门瓜料，</span>
              <span className="font-heading">一份能翻的合集</span>
              <span className="block mt-1 text-primary-600">
                今天又在 17吃瓜 把进度补上了
              </span>
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl">
              {heroLead}
            </p>

            <div className="mt-6 flex flex-wrap gap-2.5">
              <a
                href="#heji"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 text-background-50 text-sm font-semibold px-5 py-2.5 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                打开吃瓜合集
                <i className="ri-arrow-down-line text-[15px]" />
              </a>
              <a
                href="#pandian"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 text-foreground-800 text-sm font-semibold px-5 py-2.5 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
              >
                看年度盘点
                <i className="ri-video-line text-[15px]" />
              </a>
            </div>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {heroQuick.map((q, i) => (
                <div
                  key={i}
                  className="rounded-lg bg-background-50 border border-background-200 px-3.5 py-3 flex items-center gap-2"
                >
                  <span
                    className={
                      "flex items-center justify-center w-5 h-5 rounded-full " +
                      (i % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-900")
                    }
                  >
                    <i className={i % 2 === 0 ? "ri-leaf-fill text-[11px]" : "ri-flag-2-fill text-[11px]"} />
                  </span>
                  <span className="text-xs font-medium text-foreground-700 leading-tight">{q}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 视觉陪衬：今日焦点卡 */}
          <div className="lg:col-span-5">
            <article className="group rounded-xl bg-background-50 border border-background-200 overflow-hidden hover:border-primary-200 transition-colors">
              <div className="relative w-full h-[300px] md:h-[340px] overflow-hidden">
                <img
                  src={heroFeature.cover}
                  alt="今日焦点 瓜料合集视觉"
                  title="17吃瓜 今日焦点精选"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold px-3 py-1.5">
                  <i className="ri-fire-fill text-[13px]" />
                  {heroFeature.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {heroFeature.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{heroFeature.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="text-xs text-foreground-500">{heroFeature.meta}</span>
                  <a
                    href="#jingxuan"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
                  >
                    进精选看全文
                    <i className="ri-arrow-right-line text-[13px]" />
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}